<template>
   <div style="background-color: #fff;padding: 20px;">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">會員管理</div>
         <div class="breadcrumb-item">新增会员</div>
      </div>
      <Form :model="formItem" :label-width="120" style="width: 50%;">
         <FormItem label="用户名">
            <Input v-model="formItem.user_name" placeholder="请输入账号"></Input>
         </FormItem>
         <FormItem label="账号（手机号）">
            <Input v-model="formItem.user_phone" placeholder="请输入账号"></Input>
         </FormItem>
         <FormItem label="密码">
            <Input v-model="formItem.user_password" type="password" placeholder="请输入密码"></Input>
         </FormItem>
         <FormItem label="结算天数">
            <Input v-model="formItem.user_order_type" type="number" placeholder="请输入结算天数"></Input>
         </FormItem>
         <FormItem label="初始积分">
            <Input v-model="formItem.user_integral" type="number" placeholder="请输入初始积分"></Input>
         </FormItem>
         <div style="display: flex;">
            <FormItem label="门店">
               <Select v-model="formItem.store_id">
                  <Option :value="item.ReceivingID" v-for="item in storeList" :key="item.ReceivingID"
                          v-if="item.Type==1">{{ item.ReceivingName }}
                  </Option>
               </Select>
            </FormItem>
            <FormItem label="智能柜">
               <Select v-model="formItem.store_id">
                  <Option :value="item.ReceivingID" v-for="item in storeList" :key="item.ReceivingID"
                          v-if="item.Type==2">{{ item.ReceivingName }}
                  </Option>
               </Select>
            </FormItem>
         </div>
         <FormItem label="用户类型">
            <RadioGroup v-model="formItem.user_type">
               <Radio label="1">一般用户</Radio>
               <Radio label="2">BTB用户</Radio>
               <Radio label="3">其他用户</Radio>
               <Radio label="4">核销商户</Radio>
            </RadioGroup>
         </FormItem>
         <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">确定</Button>
            <Button style="margin-left: 8px" @click="$router.back()">返回</Button>
         </FormItem>
      </Form>
   </div>

</template>
<script>
export default {
   data() {
      return {
         formItem: {
            user_name:'',
            user_phone:'',
            user_password:'',
            user_order_type:'',
            user_integral:'',
            store_id:'',
            user_type:'',
         },
         storeList: [],
      }
   },
   created() {
      this.getStoreList()
   },
   methods: {
      async handleSubmit() {
         const {code, msg} = await this.$Rq.requestAuth({
            url: this.$Api.addUser,
            method: 'post',
            data: this.formItem
         })
         if (code !== 0) {
            this.$message.error(msg)
            return false
         }
         this.$message.success(msg)
         this.cancelForm()
      },
      async getStoreList() {
         const {code, data: {data}} = await this.$Rq.requestAuth({
            url: ` ${this.$Api.pickAddress}?company_id=1`,
            method: 'get'
         })
         if (code === 0) {
            this.storeList = data;
         }
      },
      cancelForm() {
         for (const formItemKey in this.formItem) {
            this.formItem[formItemKey] = ''
         }
      }
   }
}
</script>
